export default __webpack_public_path__ + "static/logo2.bdaa5ee526e6a86b93e25f1d9317a94d.png";